import { Checkbox } from '@mui/material';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ChangeEventHandler, FC, useCallback } from 'react';

export const CheckBoxCellRenderer: FC<CustomCellRendererProps> = ({ column, value, node }) => {
    const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
        (event) => {
            if (column?.isCellEditable?.(node)) {
                const newValue = event.target.checked;
                node.setDataValue(column.getColId(), newValue);
            }
        },
        [column, node]
    );

    const isChecked = Boolean(value);

    return (
        <Checkbox
            color="companyPrimary"
            disabled={!column?.isCellEditable?.(node)}
            checked={isChecked}
            readOnly={!column?.isCellEditable?.(node)}
            data-testid={`checkbox-cell-renderer`}
            onChange={handleChange}
        />
    );
};
